import type {RelayCompat} from '@github-ui/server-persisted-queries/relay-compat'

import {IssueTemplateItem} from './IssueTemplateItem'
import type {IssueFormNode} from './template-list-query-types'
import {IssueCreationKind} from './utils/model'
import {getTemplateUrl} from './utils/urls'

// RELAY-CLEANUP(TemplateList): widens nullable fields so the still-Relay parent data is assignable.
// Remove when TemplateList leaves Relay.
export type IssueFormRowFragment = RelayCompat<Pick<IssueFormNode, 'name' | 'description' | 'filename'>>

type IssueFormRowProps = {
  onTemplateSelected?: (filename: string, kind: IssueCreationKind) => void
  form: IssueFormRowFragment
  nameWithOwner: string
}

export const IssueFormRow = ({nameWithOwner, form, onTemplateSelected}: IssueFormRowProps) => {
  return (
    <IssueTemplateItem
      filename={form.filename}
      onTemplateSelected={filename => onTemplateSelected?.(filename, IssueCreationKind.IssueForm)}
      name={form.name}
      about={form.description}
      link={onTemplateSelected ? undefined : getTemplateUrl(nameWithOwner, form.filename)}
    />
  )
}
